import { gql } from 'apollo-boost'

const CREATE_SCRAPING_TAG_GROUP = gql`
  mutation createScrapingTagGroup(
    $alias: String
    $description: String
    $tagIds: [ID!]!
  ) {
    createScrapingTagGroup(
      alias: $alias
      description: $description
      tagIds: $tagIds
    )
  }
`

export default CREATE_SCRAPING_TAG_GROUP
